import { render, staticRenderFns } from "./editService.vue?vue&type=template&id=d8a4f5ce"
import script from "./editService.vue?vue&type=script&lang=js"
export * from "./editService.vue?vue&type=script&lang=js"
import style0 from "./editService.vue?vue&type=style&index=0&id=d8a4f5ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports